import React, { useEffect, useState } from 'react';
import { KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import { useSelector } from 'react-redux';
import Translate from '../../shared/localization/localize';
import DialogHeader from '../../shared/dialog/dialogHeader';
import { ReduxState } from '../../../interfaces';
import DialogSection from '../../shared/dialog/dialogSection';
import { openDialog } from '../../../modules/dialogs/download';
import useUserEKS from '../../../hooks/useUserEKS';
import {
  DownloadLog,
  getLatestLogs,
  getMoreLogs,
  mapLog,
  msgHistoryHeader,
} from '../../../modules/dialogs/downloadLogs';
import { Historical } from '../../../modules/historical/context';
import LogMappedList from '../../shared/historical/LogMappedList';
import useDialog from '../../shared/dialog/useDialog';
import Logger from '../../../libs/logger'; 
import { LogArea } from '../../../libs/logger/const';

const DownloadLogsDialog: React.FC = () => {
  const { setDialog } = useDialog();
  const { historical } = useSelector(
    (s: ReduxState) => s.dialogState.downloadLogsState
  );
  const isAllowed = true; // hasRole(props.userRoles, [appRoles.superuser, appRoles.user])
  const [updatedOn, setUpdatedOn] = useState(undefined as Date | undefined);
  const { roles: userRoles } = useUserEKS();

  useEffect(() => {
    if (!updatedOn) {
      getLatestLogs();
      setUpdatedOn(new Date(Date.now()));
    }
  }, [updatedOn]);

  if (!isAllowed) {
    Logger.warn(
      [
        'It should not have reach that component. User has not the right role.',
        userRoles,
      ],
      LogArea.Security
    );
    setDialog?.();
    return <></>;
  }

  const mainSection = (
    <>
      <DialogSection isMain scrollable>
        <Historical<DownloadLog>
          value={{ historical, getLatestLogs, getMoreLogs }}
        >
          <LogMappedList mapLog={mapLog} />
        </Historical>
      </DialogSection>
    </>
  );

  return (
    <KFLDialog
      header={
        <DialogHeader
          title={<Translate message={msgHistoryHeader} />}
          fnCloseDialog={() => setDialog?.()}
          fnBackDialog={() => openDialog()}
        />
      }
      sections={[mainSection]}
    />
  );
};

export default DownloadLogsDialog;
